import { useContext } from "react";
import { useSelector } from "react-redux";
import { Id, Identifiable, Group } from "@planzone/dto";
import { Boundaries } from "@planzone/core";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  group: Identifiable<Group>;
  retrieveResourceGroup(
    groupId: Boundaries["retrieveResourceGroup"]["request"],
  ): void;
}

function useRetrieveResourceGroup(Id: Id): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isResourceGroupRetrievalRequestPending(Id),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isResourceGroupRetrievalRequestSuccess(Id),
    ),
    isRequestFailure: useSelector(() =>
      selector.isResourceGroupRetrievalRequestFailure(Id),
    ),
    group: useSelector(() => selector.getResourceGroup(Id)),
    retrieveResourceGroup: core.retrieveResourceGroup,
  };
}

export { useRetrieveResourceGroup };
